import { useAuthStore } from "@/domains/auth";
import { resetTenantScopedStores } from "../services/tenant-scope-reset.service";
export function useOrganizationContextSwitch() {
    const authStore = useAuthStore();
    function switchToMembershipOrg(membership) {
        resetTenantScopedStores();
        authStore.switchOrg(String(membership.org_id));
    }
    function switchToSuperAdminOrg(organization) {
        resetTenantScopedStores();
        authStore.selectOrgContext({
            org_id: organization.id,
            role_key: organization.org_type === "concierge" ? "concierge_owner" : "provider_owner",
            org_name: organization.display_name,
            org_type: organization.org_type,
            org_status: organization.deleted_at
                ? "deleted"
                : organization.is_active
                    ? "active"
                    : "inactive",
            is_active: organization.is_active && !organization.deleted_at,
        });
    }
    function enterGlobalConsole() {
        resetTenantScopedStores();
        authStore.selectGlobalContext();
    }
    return {
        resetTenantScopedStores,
        switchToMembershipOrg,
        switchToSuperAdminOrg,
        enterGlobalConsole,
    };
}
export default useOrganizationContextSwitch;
